import React from "react";
import { Alert, Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import TemplateList from "./TemplateList";
import UploadWizard from "./UploadWizard";
import PositionEditor from "./PositionEditor";

const AgreementTemplates = () => {
	const roleFromState = useSelector((state) => state.role);
	const isAdminFlag = useSelector((state) => state.isAdmin);
	const role = roleFromState || (isAdminFlag === 1 ? "admin" : "manager");

	if (role !== "admin") {
		return (
			<Box m={2}>
				<Alert severity="warning">Only admins can manage landlord agreement templates.</Alert>
			</Box>
		);
	}

	return (
		<Box m="20px">
			<Routes>
				<Route index element={<TemplateList />} />
				<Route path="new" element={<UploadWizard />} />
				<Route path=":templateId/edit" element={<PositionEditor />} />
				<Route path="*" element={<Navigate to="/agreement-templates" replace />} />
			</Routes>
		</Box>
	);
};

export default AgreementTemplates;
